$('.card__sticker').each(function () {
    let $card = $(this).closest('.card'),
        width = $(this).outerWidth() - 20;

    $card.find('.card__title').css('paddingRight', width);
});
